




















import { isEmpty } from 'lodash'
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

import RecurringTargets from "../../../../../../../../components/RecurringTargets.vue";
import { Tariff } from "../../../../../../includes/types/Config";
import { InvoiceInfoWithTargets } from "../../../../../../includes/types/Shared/InvoiceInfo.types";

@Component({
  components: {
    RecurringTargets
  }
})
export default class RecurringCard extends Vue {
  @Prop() invoice!: InvoiceInfoWithTargets

  @Emit()
  deleteRecurringInvoice() {
    return this.invoice
  }

  get tariffs() {
    return this.$store.state.AdminTemplate.applicationConfig.serviceData?.tariffs
  }

  licenseTitle(tariff_id: number) {
    if (!isEmpty(this.tariffs)) {
      const tariff = Object.entries(this.tariffs).find(([ k, v ]) => {
        if ((v as Tariff)?.id === tariff_id) {
          return k
        }
      })

      if (tariff) {
        return tariff[0]
      }
    }

    return null
  }
}
